var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 15.0001V16.6667C11.333 17.1088 11.1574 17.5327 10.8449 17.8453C10.5323 18.1578 10.1084 18.3334 9.66634 18.3334H2.99967C2.55765 18.3334 2.13372 18.1578 1.82116 17.8453C1.5086 17.5327 1.33301 17.1088 1.33301 16.6667V7.50008C1.33301 7.05805 1.5086 6.63413 1.82116 6.32157C2.13372 6.00901 2.55765 5.83341 2.99967 5.83341H4.66634L11.333 15.0001ZM10.2372 1.66675H6.33301C5.89098 1.66675 5.46706 1.84234 5.1545 2.1549C4.84194 2.46746 4.66634 2.89139 4.66634 3.33341V13.3334C4.66634 13.7754 4.84194 14.1994 5.1545 14.5119C5.46706 14.8245 5.89098 15.0001 6.33301 15.0001H12.9997C13.4417 15.0001 13.8656 14.8245 14.1782 14.5119C14.4907 14.1994 14.6663 13.7754 14.6663 13.3334V6.03508C14.6663 5.81305 14.6219 5.59326 14.5358 5.38862C14.4496 5.18398 14.3235 4.99862 14.1647 4.84341L11.4022 2.14175C11.0908 1.8373 10.6727 1.6668 10.2372 1.66675V1.66675Z",
    stroke: "#6C757D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e482dde9d9673cad5d61ffbf43b16754.svg";
export { ForwardRef as ReactComponent };